<template>
  <div>
    <h1 class="animated fadeIn delay-125 title is-size-5-mobile mqu-subtitle">Let's get started</h1>
    <div class="content">
      <p>You need a summary of fees and costs for the retirement village. This information can be found in:</p>
      <ul>
        <li>The contract, or</li>
        <li>A disclosure document, fact sheet or similar document, or</li>
        <li>From the Frequently Asked Questions (FAQs) section on village website.</li>
      </ul>
      <p>Or ask the village representative to send you all the key information about costs and contract terms.</p>
      <p>Getting this information is essential for making an informed decision.</p>
      <p>It takes about 10 minutes to enter the data.</p>
      <p>For more information about the calculator, click <router-link to="/information">here</router-link>.</p>
      <p>To contact us, click <router-link to="/contact">here</router-link>.</p>
    </div>
    <br/>
    <h1 class="animated fadeIn delay-375 title is-size-5-mobile mqu-subtitle">Disclaimer</h1>
    <article class=" animated fadeIn delay-500 tile is-child notification is-light">
      <p>The retirement village calculator on this website aims to help consumers compare the cost of retirement villages. The calculations are intended as a guide only and do not constitute financial advice. Macquarie University takes care in preparing the formulae used within the calculator but does not guarantee the accuracy, reliability, completeness or suitability of the calculations provided. Users of the calculator should seek professional financial advice before making any decisions based on the calculations. Macquarie University and other organisations providing links to the calculator are not liable for any loss or damage a person suffers because they directly or indirectly rely on calculations or information provided on this website.</p>
    </article>
    <br/>
    <div class="field">
      <b-checkbox v-model="agree">I agree to the terms of the disclaimer.</b-checkbox>
    </div>
  </div>
</template>

<script>
export default {
  props: ['value'],
  data() {
    return {
      agree: this.value
    }
  },
  watch: {
    agree: function(val) {
      this.update()
    }
  },
  methods: {
    update: function() {
      this.$emit('input', this.agree)
    }
  }
}
</script>

<style scoped>
.mqu-title {
  font-family: 'National-Extrabold';
}

.mqu-subtitle {
  font-family: 'National-Light';
}

.delay-125 {
  animation-delay: 0.125s;
}

.delay-250 {
  animation-delay: 0.25s;
}

.delay-375 {
  animation-delay: 0.375s;
}

.delay-500 {
  animation-delay: 0.5s;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/stages/Start.vue